import RuleRic14 from './RIC_14'

export default {
  ...RuleRic14,
  gradeLevelId: 15
}
